import { useNavigate, useSearchParams } from "react-router-dom";
import PageLoading from "../../../components/layout/PageLoading";
import exchangeCode from "../../../api/auth/stripe/exchangeCode";
import useAuthStore from "../../../stores/useAuthStore";
import useAlertStore from "../../../stores/useAlertStore";

export default function StripeOauth() {
  const { setOrganization } = useAuthStore();
  const { setAlertMessage } = useAlertStore();

  const [ searchParams ] = useSearchParams();
  const code = searchParams.get('code');

  const navigate = useNavigate();

  if(code) {
    exchangeCode(code, (response) => {
      setOrganization(response);
      setAlertMessage('Stripe connected successfully', 'success');
      navigate('/configuration/stripe');
    }, () => {
      setAlertMessage('Stripe connection failed', 'error');
      navigate('/configuration/stripe');
    });
  }

  return <PageLoading />;
}